import React from 'react';

import {
	BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK,
	BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM,
	BLOCK_ACTIONS_TEMPLATE_SECTION,
	MAIN_BLOCK_MENU_SECTION_RANK,
} from '@atlaskit/editor-common/block-menu';
import type { RegisterBlockMenuComponent } from '@atlaskit/editor-plugin-block-menu/blockMenuPluginType';

import {
	TemplateGalleryBlockMenuItem,
	TemplateGalleryBlockMenuSection,
} from './TemplateGalleryBlockMenuItem';

export const getTemplateGalleryBlockMenuComponents = (
	onOpenTemplateGallery: () => void,
): RegisterBlockMenuComponent[] => [
	{
		type: 'block-menu-section',
		key: BLOCK_ACTIONS_TEMPLATE_SECTION.key,
		rank: MAIN_BLOCK_MENU_SECTION_RANK[BLOCK_ACTIONS_TEMPLATE_SECTION.key],
		component: TemplateGalleryBlockMenuSection,
	},
	{
		type: 'block-menu-item',
		key: 'block-templates',
		parent: {
			type: 'block-menu-section',
			key: BLOCK_ACTIONS_TEMPLATE_SECTION.key,
			rank: BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK[
				BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM.key
			],
		},
		component: () => <TemplateGalleryBlockMenuItem onOpenTemplateGallery={onOpenTemplateGallery} />,
	},
];
